export default __webpack_public_path__ + "1e4cbc519c48b0ab4e64a68bac965999.svg";